import React from 'react';

export interface IDropdownProps {
	value: string;
	direction?: EDropdownDirection;
	disabled?: boolean;
	children: React.ReactNode;
	label?: string;
	classNames?: string;
}

export enum EDropdownDirection {
	BOTTOM = 'bottom',
	TOP = 'top',
	DYNAMIC = 'dynamic',
}